const PlannedRegistrationQuantity = ({ planning }) => {
  if (!planning) return null;
  const { resource, durationMinutes, quantity } = planning;
  if (!resource) return;

  if (resource.type === 0 || resource.type === 3) {
    return durationMinutes ? durationMinutes.minuteToTime() : null;
  }
  return quantity;
};
export default PlannedRegistrationQuantity;
